// extracted by mini-css-extract-plugin
module.exports = {"bounce":"highlight-marker_bounce__nZlcC","bouncyPointerWrapper":"highlight-marker_bouncyPointerWrapper__rf_tS"};